<mat-selection-list [multiple]="false" #financeCreditBalance>
    <mat-list-option
        [value]="financeCredit"
        (click)="selectPaymentMethod()"
        [selected]="paymentMethodSelected === PaymentMethodsEnum.FINANCE"
        checkboxPosition="before"
        color="primary"
    >
        <div class="pe-3">
            <div class="d-flex flex-row align-items-center mb-2">
                <app-lib-logo-payment-method
                    [paymentMethodName]="PaymentMethodsEnum.FINANCE"
                    [width]="'2.3em'"
                    [height]="'24px'"
                    class="me-3 border-0"
                />
                <div class="d-flex flex-column">
                    <div class="d-flex color-gray-80">SprintPay Flex</div>
                </div>
            </div>
            <div class="d-flex">
                <p class="mb-0 color-gray-80 me-2">
                    Credit Available: {{ financeCredit?.balance?.avaliableCredit | currency }}
                </p>
                @if (!isEnoughCredit) {
                    <mat-icon class="warning-color" [matTooltip]="insufficientCreditWarning">info</mat-icon>
                }
            </div>
        </div>
    </mat-list-option>
</mat-selection-list>
